import React, { Suspense, lazy, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';
import NotFound from './NotFound';

const SearchablePage = lazy(() => import('./SearchablePage'));
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SLUG_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

const Loading = () => (
  <div className="admin-loading" data-testid="site-page-loading" style={{ color: '#0F766E', minHeight: '60vh' }}>
    <Loader2 className="admin-spinner" size={28} />
  </div>
);

// Catch-all route: shows a published imported page for /{slug}, otherwise the 404 page.
export default function SitePageRoute() {
  const { pathname } = useLocation();
  const slug = pathname.replace(/^\/+|\/+$/g, '');
  const valid = SLUG_RE.test(slug);
  const [state, setState] = useState({ slug: null, page: null });

  useEffect(() => {
    if (!valid) return undefined;
    let off = false;
    axios.get(`${API}/site-pages/${slug}`)
      .then((r) => { if (!off) setState({ slug, page: r.data }); })
      .catch(() => { if (!off) setState({ slug, page: false }); });
    return () => { off = true; };
  }, [slug, valid]);

  if (!valid) return <NotFound />;
  if (state.slug !== slug) return <Loading />;
  if (!state.page) return <NotFound />;
  return <Suspense fallback={<Loading />}><SearchablePage page={state.page} /></Suspense>;
}
